module.exports = __webpack_public_path__ + "img/floor-plan.f95c1129.svg";